import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Entity, EntityKey} from '../../entity/entity';
import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field';

@Component({
    selector: 'app-add-schedule-dialog',
    templateUrl: './add-schedule-dialog.component.html',
    styleUrls: ['./add-schedule-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatLabel, MatInput, FormsModule, MatHint, MatButton]
})
export class AddScheduleDialogComponent {
  private dialogRef = inject<MatDialogRef<AddScheduleDialogComponent>>(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);


  projectName!: string;
  locationCity!: string;
  locationState!: string;
  locationZip!: string;
  notes!: string;

  cancel(): void {
    this.dialogRef.close();
  }

  isValid(): boolean {
    return (this.projectName?.trim()?.length || 0) > 0;
  }

  create(): void {
    if (this.isValid()) {
      const schedule: Entity = new Entity();
      const key: EntityKey = new EntityKey();
      key.entityName = 'QUOTE';
      key.entityRevision = 0;
      schedule.id = key;
      schedule.projectName = this.projectName;
      schedule.overrideShipToCityName = this.locationCity;
      schedule.overrideShipToStateCode = this.locationState;
      schedule.overrideShipToPostalCode = this.locationZip;
      schedule.externalNotes = this.notes;
      this.dialogRef.close(schedule);
    }
  }

}
